import Check from './Check.vue'
export default Check